import * as React from 'react';
import cx from 'classnames';

import Iframe from '../Iframe/Iframe';
import { Link } from '../Link/Link';
import { getLinkHost } from '../../utils/link';
import { track } from '../../utils/analytics';

import * as cs from './SlidesEmbed.module.css';

interface Props {
  url: string;
}

const SPEAKERDECK_HOST = 'speakerdeck.com';
const SLIDESCOM_HOST = 'slides.com';
const SLIDESHARE_HOST = 'slideshare.net';

// Supports SpeakerDeck, slides.com, SlideShare.
// For SpeakerDeck: please use _embed_ link (should look like `https://speakerdeck.com/player/XXXXXX`), not the regular one. Share icon in the bottom right corner of the slides -> Embed -> Beginning -> Copy iframe embed code. Copy and passte only src="XXXXX" from the code.
// For SlideShare: please use _embed_ link (should look like `https://www.slideshare.net/slideshow/embed_code/key/XXXXXX`), not the regular one. Share icon under the slides, after the heart icon -> Embed. Copy and passte only src="XXXXX" from the code, add "https" to the beginning.
// For slides.com use regular link URL.
// For other services or direct links to the file it will be displayed as a plain link.
export const SlidesEmbed = ({ url }: Props) => {
  const handleClick = () => {
    track('event-media-slides-click', url);
  };

  const falback = (
    <Link to={url} target="_blank">
      {url}
    </Link>
  );

  const host = getLinkHost(url);

  if (host === SPEAKERDECK_HOST) {
    return (
      <div className={cx(cs.slides, cs.speakerdeck)}>
        <Iframe
          title={url}
          src={url}
          width="100%"
          height="100%"
          className={cs.player}
          allowFullScreen
          scrolling="no"
          allow="encrypted-media;"
          onInferredClick={handleClick}
        />
      </div>
    );
  }

  if (host === SLIDESCOM_HOST) {
    return (
      <Iframe
        title={url}
        src={`${url}/embed`}
        width="100%"
        height="420"
        scrolling="no"
        frameBorder="0"
        allowFullScreen
        onInferredClick={handleClick}
      />
    );
  }

  if (host === SLIDESHARE_HOST) {
    return (
      <div className={cx(cs.slides, cs.slideshare)}>
        <Iframe
          title={url}
          src={url}
          width="100%"
          height="100%"
          frameBorder="0"
          marginWidth={0}
          marginHeight={0}
          scrolling="no"
          allowFullScreen
          onInferredClick={handleClick}
          className={cs.player}
        />
      </div>
    );
  }

  return falback;
};
